import { FC } from 'react';

// material-ui
import Box from '@mui/material/Box';

// ==============================|| ERRORS - CODE BLOCK (monospace, theme-styled) ||============================== //

export const CodeBlock: FC<{ children: string }> = ({ children }) => (
	<Box
		component="pre"
		sx={{
			m: 0,
			p: 1.5,
			borderRadius: 1,
			bgcolor: 'background.default',
			border: '1px solid',
			borderColor: 'divider',
			color: 'text.secondary',
			fontFamily: 'monospace',
			fontSize: '0.75rem',
			lineHeight: 1.6,
			whiteSpace: 'pre-wrap',
			wordBreak: 'break-word',
			overflow: 'auto',
			maxHeight: 280
		}}
	>
		{children}
	</Box>
);
